import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import { HTTPError } from '../libs/http-error';
export var ApiClientEvents;

(function (ApiClientEvents) {
  ApiClientEvents["OPEN"] = "onopen";
  ApiClientEvents["ERROR"] = "onerror";
  ApiClientEvents["INIT"] = "INIT";
  ApiClientEvents["HEARTBEAT"] = "HEARTBEAT";
  ApiClientEvents["LOGOUT"] = "LOGOUT";
})(ApiClientEvents || (ApiClientEvents = {}));

export var ApiClientState;

(function (ApiClientState) {
  ApiClientState[ApiClientState["CONNECTING"] = 0] = "CONNECTING";
  ApiClientState[ApiClientState["OPEN"] = 1] = "OPEN";
  ApiClientState[ApiClientState["CLOSED"] = 2] = "CLOSED";
})(ApiClientState || (ApiClientState = {}));

export var ApiClient = /*#__PURE__*/function () {
  function ApiClient(config) {
    _classCallCheck(this, ApiClient);

    _defineProperty(this, "config", void 0);

    this.config = config;
  }

  _createClass(ApiClient, [{
    key: "imAlive",
    value: function () {
      var _imAlive = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch("".concat(this.config.serviceUrl, "/session"), {
                  credentials: 'include'
                });

              case 2:
                response = _context.sent;

                if (!(!response.ok && response.status !== 401)) {
                  _context.next = 5;
                  break;
                }

                throw new HTTPError(response);

              case 5:
                return _context.abrupt("return", response.ok);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function imAlive() {
        return _imAlive.apply(this, arguments);
      }

      return imAlive;
    }()
  }, {
    key: "login",
    value: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(serviceTicket) {
        var response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return fetch("".concat(this.config.serviceUrl, "/init?ticket=").concat(serviceTicket), {
                  credentials: 'include'
                });

              case 2:
                response = _context2.sent;

                if (response.ok) {
                  _context2.next = 5;
                  break;
                }

                throw new HTTPError(response);

              case 5:
                return _context2.abrupt("return", true);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function login(_x) {
        return _login.apply(this, arguments);
      }

      return login;
    }()
  }, {
    key: "subscribe",
    value: function subscribe() {
      return new EventSource("".concat(this.config.serviceUrl, "/subscribe"), {
        withCredentials: true
      });
    }
  }]);

  return ApiClient;
}();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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